<template>
  <div class="full-container">
    <div
        style="width: 100%;float: left;height: 50px;line-height: 50px;font-size: 0.9rem; text-align: left;opacity: 0.9;">
      商户管理
    </div>
    <div style="width:100%;height:auto;float:left;border-radius: 15px;background-color: white;padding-bottom:40px;">
      <div style="width:100%;float:left;margin-top: 10px;">
        <!-- 查询按钮区 -->
        <div style="width: 100%;height: 60px;float: left;line-height: 60px;padding-left: 15px">
          <div style="width: auto;float: left;margin-right: 20px">
            <label style="float: left;font-size: 0.9rem;opacity: 0.9;">商户号：</label>
            <el-input v-model="selectForm.merchantNo" clearable placeholder="模糊查询" prefix-icon="el-icon-search"
                      size="mini" style="width: 200px;float: left;"></el-input>
          </div>
          <div style="width: auto;float: left;margin-right: 20px">
            <label style="float: left;font-size: 0.9rem;opacity: 0.9;">商户名称：</label>
            <el-input v-model="selectForm.companyName" clearable placeholder="模糊查询" prefix-icon="el-icon-search"
                      size="mini" style="width: 200px;float: left;"></el-input>
          </div>
          <div style="width: auto;float: left;margin-right: 20px">
            <el-button size="mini" style="background-color: #25AD7F;border:none;" type="primary"
                       @click="pageMerchant(true)">搜索
            </el-button>
            <el-button size="mini" style="background-color: #25AD7F1A;border:1px solid #25AD7F;color:#25AD7F"
                       type="primary" @click="selectReset()">重置
            </el-button>
          </div>
          <!-- 右边按钮 -->
          <div style="width: auto;float: right;margin-right: 20px">
            <el-button size="mini" style="background-color: #25AD7F1A;border:1px solid #25AD7F;color:#25AD7F"
                       type="primary" @click="exportTable">
              <a-icon type="plus-circle"/>
              批量导出
            </el-button>
          </div>
        </div>
        <!-- 表单内容 -->
        <div style="width:100%;float:left;padding: 15px;">
          <el-table v-loading="tableLoading" :data="tableData" align="center" height="600"
                    size="mini" style="color: #555;" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column align="center" label="商户号" min-width="20%" prop="merchantNo"></el-table-column>
            <el-table-column align="center" label="商户名称" min-width="20%"
                             prop="merchantDetailVO.companyName" style="color: red"></el-table-column>
            <el-table-column align="center" label="具备流程服务" min-width="20%"
                             prop="merchantDetailVO.isWorkflow" style="color: red">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.isWorkflow"
                           active-color="#13ce66"
                           active-value="1" inactive-color="#ff4949" inactive-value="0" @change="updateIsWorkflow(scope.row.id,scope.row.isWorkflow)">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column label="显示在首页" min-width="20%">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.isShowIndex"
                           active-color="#13ce66"
                           active-value="1" inactive-color="#ff4949" inactive-value="0" @change="updateIsShowIndex(scope.row.id,scope.row.isShowIndex)">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column align="center" label="统一社会信用代码" min-width="20%"
                             prop="merchantDetailVO.companyIdCard" style="color: red"></el-table-column>
            <el-table-column align="center" label="负责人名称" min-width="20%"
                             prop="merchantDetailVO.chargeUserName" style="color: red"></el-table-column>
            <el-table-column align="center" label="负责人手机号码" min-width="20%"
                             prop="merchantDetailVO.chargeUserTel" style="color: red"></el-table-column>
            <el-table-column align="center" label="入驻时间" min-width="20%" prop="createDateStr"
                             sortable></el-table-column>
            <el-table-column align="center" label="操作" min-width="20%">
              <template slot-scope="scope">
                <span style="font-size:1rem;color:#25AD7F;cursor: pointer;" @click="infoShow(scope.row)">商户资料</span>
                &nbsp;
              </template>
            </el-table-column>
          </el-table>
          <div style="width: 100%;float: right;margin-top: 10px;text-align: right;">
            <el-pagination
                :current-page="selectForm.pageIndex"
                :page-size="selectForm.pageSize"
                :total="selectForm.total"
                layout="total,prev, pager, next"
                @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :before-close="infoCancel" :visible.sync="infoDialog" title="商户资料" width="40%">
      <div style="width: 100%;float: left">
        <div
            v-if="infoData&&infoData.merchantDetailVO"
            style="width: 100%;float: left;border-bottom: 1px solid #80808054;padding-bottom: 15px;margin-bottom: 20px;">
          <el-descriptions :column=2 title="主体信息">
            <el-descriptions-item label="商户名称">{{ infoData.merchantDetailVO.companyName }}</el-descriptions-item>
            <el-descriptions-item label="商户地址">{{ infoData.merchantDetailVO.companyAddress }}</el-descriptions-item>
            <el-descriptions-item label="统一社会信用代码">{{
                infoData.merchantDetailVO.companyIdCard
              }}
            </el-descriptions-item>
            <el-descriptions-item label="具备流程服务">{{
                infoData.merchantDetailVO.isWorkflowStr
              }}
            </el-descriptions-item>
            <el-descriptions-item label="营业执照">
              <el-image v-if="infoData.merchantDetailVO.companyIdCardGuid" :preview-src-list="['/admin/web/file/downloadFile?id='+infoData.merchantDetailVO.companyIdCardGuid]"
                        :src="'/admin/web/file/downloadFile?id='+infoData.merchantDetailVO.companyIdCardGuid"
                        style="width: 100px; height: 100px"
                        title="点击放大">
              </el-image>
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions :column=2 title="负责人">
            <el-descriptions-item label="姓名">{{ infoData.merchantDetailVO.chargeUserName }}</el-descriptions-item>
            <el-descriptions-item label="身份证号码">{{
                infoData.merchantDetailVO.chargeUserIdCard
              }}
            </el-descriptions-item>
            <el-descriptions-item label="手机号码">{{ infoData.merchantDetailVO.chargeUserTel }}</el-descriptions-item>
            <el-descriptions-item label="邮箱">{{ infoData.merchantDetailVO.chargeUserMail }}</el-descriptions-item>
            <el-descriptions-item label="身份证（正反面）">
              <el-image v-for="guid in infoData.merchantDetailVO.chargeUserIdCardGuid"
                        v-if="infoData.merchantDetailVO.chargeUserIdCardGuid" :preview-src-list="['/admin/web/file/downloadFile?id='+guid]"
                        :src="'/admin/web/file/downloadFile?id='+guid"
                        style="width: 100px; height: 100px"
                        title="点击放大">
              </el-image>
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button class="dialog-footer-cancel" @click="infoCancel">关闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

import {pageMerchantApi, updateIsShowIndexApi, updateIsWorkflowApi} from "@/router/api/merchant/merchant-api";
import * as XLSX from "xlsx";

export default {
  name: "MerchantIndex",
  data() {
    return {

      //查询
      tableData: [],
      selectForm: {
        merchantNo: null,
        companyName: null,
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
      selectTableRow: [],
      tableLoading: false,
      infoDialog: false,
      infoData: {},
    };
  },

  mounted() {
    this.pageMerchant();
  },

  methods: {

    // 查询 begin
    selectReset() {
      this.selectForm = {
        merchantNo: null,
        companyName: null,
        pageIndex: 1,
        pageSize: 10,
        total: 0
      }
      this.pageMerchant(true);
    },

    handleCurrentChange(e) {
      this.selectForm.pageIndex = e;
      this.pageMerchant(true);
    },

    handleSelectionChange(val) {
      this.selectTableRow = val;
    },

    pageMerchant(showMessage) {
      this.tableLoading = true;
      pageMerchantApi(this.selectForm, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              if (showMessage) {
                this.showMessage(res.data.msg, "success");
              }
              this.tableData = res.data.resultSetData.list;
              this.selectForm.pageIndex = res.data.resultSetData.pageNum;
              this.selectForm.pageSize = res.data.resultSetData.pageSize;
              this.selectForm.total = res.data.resultSetData.total;

            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      }, res => {
        this.tableLoading = false;
      });
    },

    exportTable() {
      if (!this.selectTableRow || this.selectTableRow.length == 0) {
        this.showMessage("请勾选需要导出的数据", "warning");
        return false;
      }

      const data = [
        ["商户号", "商户名称", "具备流程服务", "统一社会信用代码", "负责人名称", "负责人手机号码", "入驻时间",]
      ];

      //添加数据
      for (let i = 0; i < this.selectTableRow.length; i++) {
        let row = this.selectTableRow[i];
        if (row) {
          let cell1 = row.merchantNo;
          let cell2 = row.merchantDetailVO ? row.merchantDetailVO.companyName : "";
          let cell3 = row.isWorkflowStr;
          let cell4 = row.merchantDetailVO ? row.merchantDetailVO.companyIdCard : "";
          let cell5 = row.merchantDetailVO ? row.merchantDetailVO.chargeUserName : "";
          let cell6 = row.merchantDetailVO ? row.merchantDetailVO.chargeUserTel : "";
          let cell7 = row.createDateStr;
          data.push([cell1, cell2, cell3, cell4, cell5, cell6, cell7]);
        }
      }
      // 将数据转换为工作表
      const worksheet = XLSX.utils.aoa_to_sheet(data);

      // 创建工作簿并添加工作表
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // 生成Excel文件
      const excelBuffer = XLSX.write(workbook, {bookType: "xlsx", type: "array"});

      // 使用blob和FileReader创建一个Blob URL
      const dataBlob = new Blob([excelBuffer], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"});
      const blobUrl = window.URL.createObjectURL(dataBlob);

      // 使用saveAs下载文件
      saveAs(dataBlob, "商户-" + new Date().toLocaleString() + ".xlsx");

      // 清理
      window.URL.revokeObjectURL(blobUrl);
    },
    // 查询 end

    updateIsWorkflow(id, isWorkflow) {
      let params = {
        "id": id,
        "isWorkflow": isWorkflow
      };
      updateIsWorkflowApi(params, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.showMessage(res.data.msg, "success");
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });
    },


    updateIsShowIndex(id, isShowIndex) {
      let params = {
        "id": id,
        "isShowIndex": isShowIndex
      };
      updateIsShowIndexApi(params, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.showMessage(res.data.msg, "success");
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });
    },


    infoShow(data) {
      this.infoDialog = true;
      this.infoData = data;
    },

    infoCancel() {
      this.infoDialog = false;
      this.infoData = {};
    },

    // 工具
    parseDate(date) {
      if (date) {
        return new Date(date).toLocaleString();
      }
      return "";
    }
  }

};

</script>


<style scoped>

.dialog-footer {
  width: 100%;
  float: left;
  text-align: left;
}

.dialog-footer-submit {
  background-color: #25AD7F;
  color: white;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

.dialog-footer-submit:hover {
  background-color: #25AD7F;
  color: white;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

.dialog-footer-cancel {
  background-color: white;
  border: 1px solid #8080805c;
  color: #8080805c;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

.dialog-footer-cancel:hover {
  background-color: white;
  border: 1px solid #8080805c;
  color: #8080805c;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

/* 树形菜单 */

/deep/ .el-tree-node__content {
  height: 35px;
  line-height: 35px;
}

/* 表格 */

/deep/ .el-table th.el-table__cell {
  background-color: #F8F8F8;
}

/deep/ .el-table th.el-table__cell > .cell {
  color: #554 !important;
  font-weight: 600;
  font-size: 1.05rem;
}

/* 模态框 */

/deep/ .el-dialog__title {
  font-weight: 600;
}

/deep/ .el-dialog__header {
  text-align: left;
  border-bottom: 1px solid darkgray;
}

/deep/ .el-dialog__body {
  width: 100%;
  float: left;
  background-color: white;
}

/deep/ .el-upload-dragger {
  height: auto;
}

/deep/ .el-form-item__content {
  text-align: left;
}

</style>
